/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { UnitDependencies } from './dependenciesUnitClass.generated.js';
import { createMolarMass } from '../../factoriesAny.js';
export var molarMassDependencies = {
  BigNumberDependencies,
  UnitDependencies,
  createMolarMass
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesMolarMass.generated.js
// module id = null
// module chunks = 